// Models
// Utilities
import { LocalIdGenerator } from "@ms/uno-utilities/lib/local/LocalIdGenerator";
/**
 * Base class for versioned odata entities.
 * This class provides a common structure for entities that have an id and version,
 * and defines methods for serialization and deletion.
 */ export class BaseODataEntity {
    /**
     * Get the serialized representation of the entity for deletion.
     */ forDelete() {
        return {
            id: this.id,
            "@etag": this.version
        };
    }
    constructor(propertyBag){
        this.id = propertyBag.id ?? LocalIdGenerator.generate();
        this.version = propertyBag.version ?? "1";
    }
}
